var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13L7.49997 12.5C7.77614 12.2239 8.22398 12.2239 8.50018 12.5001C8.77631 12.7761 9.22403 12.7762 9.50009 12.5C9.77617 12.2239 10.2239 12.2239 10.5 12.5C10.7761 12.7761 11.2239 12.7761 11.5 12.5C11.7761 12.2239 12.2239 12.2238 12.5 12.4999L13.0002 13",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 6.24266L8.77832 4.12134L3.28839 9.61127C3.17862 9.72104 3.09591 9.85487 3.04682 10.0021L2.37703 12.0115C2.24674 12.4024 2.61861 12.7742 3.00949 12.6439L5.01883 11.9742C5.16611 11.9251 5.29994 11.8424 5.40971 11.7326L10.8996 6.24266Z",
    fill: "#002A69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1923 2.70711C10.5828 2.31658 11.216 2.31658 11.6065 2.70711L12.3136 3.41421C12.7042 3.80474 12.7042 4.4379 12.3136 4.82843L11.6065 5.53553L9.4852 3.41421L10.1923 2.70711Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefine);
export default __webpack_public_path__ + "static/media/Refine.910eb127dbebcf4d68fe7ca430a98bd0.svg";
export { ForwardRef as ReactComponent };